// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"Footer_listWrapper__1x3Y-","soMeLogos":"Footer_soMeLogos__1aPDC","keaLogo":"Footer_keaLogo__2ReTP"};